import api from '../utils/api.js';


const state = {
  clients: [],

  activeClient: {
    name: '',
    vendors: [],
    total: {metrics: []},
    budget_groups: [],
    budget_groups_yestetday: [],
    budget: [],
    yesterdaySpend: ''
  },

  auth: {
    role: 'member'
  },

  isAdmin: false,

  currentTeam: false,

  showClientDetails: false,
};

const getters = {
  clients: state => state.clients,
  activeClient: state => state.activeClient,
  auth: state => state.auth,
  isAdmin: state => state.isAdmin,
  showClientDetails: state => state.showClientDetails,
  currentTeam: state => state.currentTeam,
};

const actions = {
  getAssignedClients(context) {
    return api.get('/api/pacing')
      .then((response) => context.commit('GET_CLIENTS', response))
      .catch((error) => console.log(error.body.message));
  },

  setAuth(context,data) {
    context.commit('SET_AUTH', data.auth);
    context.commit('SET_IS_ADMIN', data.auth.role !== 'member');
  },

  setCurrentTeam(context,data) {
    context.commit('SET_CURRENT_TEAM', data.team);
  },

  showClientDetails(context) {
    context.commit('SHOW_CLIENT_DETAILS', true);
  },

  hideClientDetails(context) {
    context.commit('SHOW_CLIENT_DETAILS', false);
    context.commit('SET_ACTIVE_CLIENT', {name: '', vendors: [], budget_groups: [], total: {metrics: []}});
  },

  getPacingForClient(context, data) {
    return new Promise((resolve, reject) => {
      api.get(`/api/pacing/${data.client}`)
        .then((response) => {
          context.commit('SET_ACTIVE_CLIENT', response);
          resolve();
        })
        .catch((error) => reject(error));
    });
  },
};

const mutations = {
  GET_CLIENTS(state, data) {
    state.clients = data.filter(row => {
      return row.client_name !== null && row.budget !== null && row.exclude_weekends !== null;
    });
  },
  SET_AUTH(state, data) {
    state.auth = data;
  },
  SET_IS_ADMIN(state, data) {
    state.isAdmin = data;
  },
  SET_CURRENT_TEAM(state, data) {
    state.currentTeam = data;
  },
  SHOW_CLIENT_DETAILS(state, data) {
    state.showClientDetails = data;
  },
  SET_ACTIVE_CLIENT(state, data) {
    state.activeClient.name = data.name;
    state.activeClient.slug = data.slug;
    state.activeClient.budget = data.budget;
    state.activeClient.yesterdaySpend = data.yesterday;
    state.activeClient.total = data.total.metrics.filter(row => {
      return row.vendor === 'Total';
    })[0];
    state.activeClient.vendors = data.total.metrics.filter(row => {
      return row.vendor !== 'Total';
    });
    if (state.activeClient.total !== undefined) {
      state.activeClient.total.exclude_weekends = data.total.exclude_weekends;
      state.activeClient.total.start = data.total.start;
      state.activeClient.total.end = data.total.end;
    }
    state.activeClient.budget_groups = data.budget_groups;
    state.activeClient.budget_groups_yestetday = data.budget_groups_yestetday;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/pacing.js